export default "__VITE_ASSET__Dl57QUWb__"